import styled from 'styled-components'
import {Button} from "@mui/material";

import MapOutlinedIcon from '@mui/icons-material/MapOutlined';

import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import { StyledButton } from 'components/Buttons/DefaultButton/DefaultButton.styles';
import { pageContainerStyles } from '../../../themes/layout';

export const Page = styled.div`
  ${pageContainerStyles}
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: white;
  overflow: visible;
  overflow-x: hidden;
  align-items: stretch; 
  width: 100%;
  box-sizing: border-box;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 1.275rem 1rem;
    border-radius: 12px;
    background-color: white;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    margin-bottom: 1rem;
    min-width: 0;
    flex-direction: column;
    max-width: 100%;
    box-sizing: border-box;
`

export const PopupContainer = styled.div`
    padding: 1.5rem 1rem;
    border-radius: 8px;
    background: white;
    max-width: 25.75rem;
    width: 100%;
    align-self: center;
`

export const TitleContainer = styled.div`
    padding: 1.275rem 1rem;
    border-radius: 12px;
    background: white;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    margin-bottom: 1rem;
    max-width: 100%;
    box-sizing: border-box;
`

export const Title = styled.div`
    margin-bottom: 8px;
    font-size: 1rem;
    line-height: 1.3;
    color: #000;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    @media (min-width: 768px) {
        font-size: var(--typography-h5-size);
    }
`

export const SubtitleSecondary = styled.div`
    display: flex;
    align-items: center;
    font-size: var(--typography-body2-size);
    line-height: 1.3;
    font-weight: 400;
    color: #000;
    opacity: 60%;
    margin-top: 0.5rem;
`

export const ShiftBox = styled.div`
    display: flex;
    flex-direction: column;
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 143%;
    letter-spacing: 0.15px;
    @media (min-width: 768px) {
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        gap: 4rem;
    }
    @media (min-width: 1200px) {
        gap: 8rem;
    }
`

export const ShiftBoxDate = styled.div`
    padding-right: 2rem;
    display: flex;
    align-items: center;
    font-size: 1rem;
    @media (min-width: 768px) {
        font-size: var(--typography-h5-size);
    }
`

export const ButtonBox = styled.div`
display: flex;
padding-top: var(--1, 0.5rem);
align-items: center;
gap: 8px;
align-self: stretch;
flex-wrap: wrap; 
flex-grow: 1; 
`

export const DefaultButton = styled(Button)`
    border-radius: var(--borderRadius, 8px);
    background: var(--common-white-main, #FFF);
    display: flex;
    padding: var(--2, 1rem);
    justify-content: center;
    align-items: center;
    flex: 1 0 0;

    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-family: var(--fontMain, 'Poppins', sans-serif),sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: var(--3, 1.5rem);
    letter-spacing: 0.4px;
    flex-direction: row;
    text-transform: none;
    gap: 0.5rem;
`

export const ShiftBoxDateTimeInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    background-color: rgba(11, 69, 152, 0.04);
    border-radius: 8px;
    border: 1px solid rgba(11, 69, 152, 0.1);
`

export const ShiftBoxRateContainer = styled.div`
`
export const ShiftBoxRateValueWrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: space-between;
`
export const ShiftBoxRate = styled.div`
display: flex;
margin-top: 1rem;
flex-direction: column;
@media (min-width: 768px) {
    align-items: start;
    margin-top: 0;
}
`

export const ShiftBoxRateTitle = styled.div`
font-size: 1rem;
line-height: 1.3;
color: #000;
font-weight: 600;
`
export const ShiftBoxRateValue = styled.div`
font-size: var(--typography-h5-size);
line-height: 1.3;
color: var(--secondary-main, #0B4598);
font-weight: 600;
vertical-align: top;
@media (min-width: 768px) {
    font-size: var(--typography-h4-size);
}
`
export const ShiftBoxRateDescription = styled.div`
font-size: 0.75rem;
line-height: 1.3;
font-weight: 500;
color: #000;
margin-top: 0.5rem;
`

export const ProposedRateDescription = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.75rem;
    line-height: 1.3;
    font-weight: 400;
    color: #000;
    opacity: 60%;
    a {
        display: contents;
        text-decoration: underline;
    }
    @media (min-width: 768px) {
        display: none;
    }
`


export const ShiftBoxContainer = styled.div`
    padding: 1.275rem 1rem;
    border-radius: 12px;
    background: white;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    margin-bottom: 1rem;
    max-width: 100%;
    box-sizing: border-box;
`
export const ContentTitle = styled.div`
    text-align: center;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.3;
    color: rgb(0,0,0,0.7);
    margin: 0 1rem 0.5rem 1rem;
`

export const EndorsmentsBox = styled.div`
    display: flex;
    flex-direction: row;
`

export const Description = styled.div`
display: flex;
flex-direction: column;
font-size: 0.75rem;
line-height: 1.3;
font-weight: 400;
color: #000;
opacity: 60%;
margin: 0.5rem 0 1rem 0;
padding: 0 1rem;
text-align: center;
a{
    text-decoration: underline;
}
@media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    a {
        margin-left: 0.2rem
    }
}
`

export const ShiftTimeDescription = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.75rem;
    line-height: 1.3;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
    padding: 0.5rem 0 0 0;
    margin-top: 0.5rem;
    
    a {
        text-decoration: underline;
    }
    
    @media (min-width: 768px) {
        a {
            margin-left: 0.2rem
        }
        max-width: 100%
    }
`

export const ModalButtons = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    max-width: 100%;
`

export const OutlinedButton = styled(Button)`
background: none;
border-color: var(--secondary-main, #0B4598) !important;
display: flex;
justify-content: center;
align-items: center;

color: var(--secondary-main, #0B4598) !important;
font-family: var(--fontMain, 'Poppins', sans-serif),sans-serif;
font-style: normal;
font-weight: 100 !important;
letter-spacing: 0.4px;
flex-direction: row;
text-transform: none;
border-radius: 50px;
`

export const ContainedButton = styled(Button)`
background: ${
    props => props.disabled
    ? '#E0E0E0' 
    : 'var(--secondary-main, #0B4598)'
} !important;
display: flex;
justify-content: center;
align-items: center;
width: 100%;
max-width: 400px;
    margin: 0 auto;
    white-space: normal;
    text-align: center;
    line-height: 1.2;
    padding: 0.875rem 1.5rem;
    font-size: 15px;

    @media (max-width: 375px) {
        font-size: 13px;
        padding: 0.75rem 1rem;
    }

color: ${
    props => props.disabled
    ? 'rgba(0, 0, 0, 0.38)' 
    : '#fff'
} !important;
font-family: var(--fontMain, 'Poppins', sans-serif),sans-serif;
font-style: normal;

@media (max-width: 480px) {
    max-width: 100%;
    padding: 0.75rem 1rem;
    font-size: 14px;
}

@media (min-width: 481px) and (max-width: 768px) {
    max-width: 360px;
    padding: 0.8rem 1.5rem;
    font-size: 15px;
}
font-weight: 100 !important;
letter-spacing: 0.4px;
flex-direction: row;
text-transform: none;
border-radius: 50px;
`

export const StickyButtonContainer = styled.div`
    background: white;
    padding: 1.25rem 1rem;
    padding-bottom: calc(1.75rem + env(safe-area-inset-bottom));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 1rem 0 0 0;
    border-top: 1px solid #e5e5e5;
    box-shadow: none;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    box-sizing: border-box;

    @media only screen and (min-width: 768px) {
        padding: 1.5rem 1rem;
        padding-bottom: calc(2rem + env(safe-area-inset-bottom));
    }
`;

export const PageWithStickyFooter = styled.div`
  ${pageContainerStyles}
  display: flex;
  flex-direction: column;
  background-color: white;
  padding-bottom: 0;
  min-height: 100%;
  position: relative;
  width: 100%;
  overflow: visible;
  overflow-x: hidden;
  box-sizing: border-box;
`;

export const PageContent = styled.div`
  flex: 1 0 auto;
  padding-bottom: calc(8rem + env(safe-area-inset-bottom));
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
  box-sizing: border-box;
`;

export const CheckMark = styled(CheckCircleOutlined)`
    width: 1.5rem;
    margin: 0 0.5rem 0 0;
    color: var(--success-main, #13CA82);
`

export const SafetyGuidelines = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 1rem 0;
    margin-bottom: 1rem;
`

export const Subtitle = styled.div`
    font-size: var(--font-size-mid);
    line-height: 1.3;
    color: #000;
    font-weight: 400;
    opacity: 60%;
    @media only screen and (max-width: 600px) {
        font-size: var(--typography-body2-size);
    }
`
export const ScentFreeDisclaimer = styled.div`
    display: block;
    padding: 0.75rem 1rem;
    margin: 0 0 1rem 0;
    color: #000;
    font-weight: 400;
    font-size: 0.8rem;
    line-height: 1.3;
    letter-spacing: 0.1px;
    max-width: 100%;
    .disclaimer-strong {
        font-weight: 800;
        color: #000;
        display: inline;
    }
    .disclaimer-link {
        background: none;
        border: none;
        padding: 0;
        margin: 0;
        color: var(--primary-blue, #0B4598);
        text-decoration: underline;
        font-weight: 700;
        white-space: nowrap;
        cursor: pointer;
        font-size: inherit;
        line-height: inherit;
        letter-spacing: inherit;
    }
    a {
        color: var(--primary-blue, #0B4598);
        text-decoration: underline;
        font-weight: 700;
        white-space: nowrap;
    }
    @media (min-width: 768px) {
        font-size: 0.9rem;
    }
`
export const UnpaidGap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    color: var(--primary-main, #FB7672);
    font-weight: 500;
    font-size: 14px;
    margin: 0 0 1rem 0;
    padding: 0.75rem 1rem;
    background-color: var(--common-white-main, #fff);
    border-radius: 8px;
    border: 1px solid var(--primary-main, #FB7672);
`

export const PartialOfferSubtitle = styled(Description)`
display: flex;
flex-direction: row;
justify-content: start;
align-items: center;
color: black !important;
margin: 0.25rem 0 0 0 !important;
`

export const PartialOfferUnlockedText = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: var(--success-main, #13CA82);
  font-size: 14px;
  font-weight: 500;
  margin: 0.5rem 0 1rem 0;
  text-align: center;
  padding: 0 1rem;
  line-height: 1.4;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  font-family: inherit;
  
  &:hover {
    opacity: 0.8;
  }
  
  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
    gap: 0.4rem;
    margin: 0.75rem 0 1rem 0;
    
    svg {
      width: 16px;
      height: 16px;
    }
  }
  
  @media (min-width: 768px) {
    font-size: 15px;
  }
`